module.exports = __webpack_public_path__ + "img/logo.4f6d9dbc.png";